import { getCSS, remNumber } from '@gimlite/common';
import classNames from 'classnames';
import { DotStream, Squircle } from 'ldrs/react';
import 'ldrs/react/DotStream.css';
import 'ldrs/react/Squircle.css';
import { observer } from 'mobx-react-lite';
import { memo } from 'react';
import { useStoreUIV2 } from '../../hooks/useStore.hook';
import { ColorType } from '../../types/component.type';
import './spinner.component.scss';

const sizeMapper = {
  small: {
    size: 16,
    stroke: 2,
  },
  medium: {
    size: 37,
    stroke: 5,
  },
} as const satisfies Record<string, { size: number; stroke: number }>;

const variantMapper = {
  dotStream: {
    defaultColor: 'white_100',
  },
  squircle: {
    defaultColor: 'deep_indigo_70',
  },
} as const satisfies Record<string, { defaultColor: ColorType }>;

export declare namespace SpinnerType {
  type Props = {
    className?: string | null;
    variant?: keyof typeof variantMapper;
    color?: ColorType;
    size?: keyof typeof sizeMapper;
  };
}

export const Spinner = memo(
  observer(
    ({
      className,
      variant = 'squircle',
      size = 'medium',
      color,
    }: SpinnerType.Props) => {
      const { AppStore } = useStoreUIV2();
      return (
        <div className={classNames('spinner', className)}>
          {variant === 'dotStream' ? (
            <DotStream
              size={remNumber(sizeMapper[size].size, AppStore.threshold)}
              color={getCSS(
                `--color-${color || variantMapper[variant].defaultColor}`,
              )}
            />
          ) : (
            <Squircle
              size={remNumber(sizeMapper[size].size, AppStore.threshold)}
              stroke={remNumber(sizeMapper[size].stroke, AppStore.threshold)}
              color={getCSS(
                `--color-${color || variantMapper[variant].defaultColor}`,
              )}
            />
          )}
        </div>
      );
    },
  ),
);
